import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=a7829720&scoped=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&id=a7829720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7829720",
  null
  
)

export default component.exports